/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerturbationName } from './PerturbationName';
import { PerturbationNameFromJSON, PerturbationNameFromJSONTyped, PerturbationNameToJSON } from './PerturbationName';

/**
 *
 * @export
 * @interface PerturbedDataset
 */
export interface PerturbedDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedDataset
   */
  readonly id: number;
  /**
   *
   * @type {PerturbationName}
   * @memberof PerturbedDataset
   */
  readonly perturbation: PerturbationName;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDataset
   */
  hasPredictions?: boolean;
}

/**
 * Check if a given object implements the PerturbedDataset interface.
 */
export function instanceOfPerturbedDataset(value: object): value is PerturbedDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  return true;
}

export function PerturbedDatasetFromJSON(json: any): PerturbedDataset {
  return PerturbedDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerturbedDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    perturbation: PerturbationNameFromJSON(json['perturbation']),
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
  };
}

export function PerturbedDatasetToJSON(value?: Omit<PerturbedDataset, 'id' | 'perturbation'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    has_predictions: value['hasPredictions'],
  };
}
